import React, { Component, useState } from 'react';
import { Field, Form } from '../../common/Form';
import { useTranslation

 } from 'react-i18next';
import { jwordFontList, jwordFontSizeList } from '../../cms/editor/jword-config';
export function RootForm(props)
{
	const {t}=useTranslation();
	const [cat,setCat]=useState({...props.cat});

	const onValChange=(data)=>{
		console.log("onValChange:"+JSON.stringify(data));
		setCat(data);
		props.onChange(data);		
	}
	const onCatAttrChange=(data)=>{
		let ct={...cat};
		ct.catAttr=data;
		props.onChange(ct);
		setCat(ct);
	}
	return(
		<>
		<Form id="formid" formData={cat} onChange={onValChange}
			fields={[
				{id:"parentGroup",ftype:"checkbox",field:"parentGroup",label:t("Main Group")},
				{id:"code",ftype:"text",field:"code",label:t("Code")},
				{id:"name",ftype:"text",field:"name",label:t("Name")},
				{id:"descr",ftype:"textarea",field:"descr",label:t("Description")},
			]}>
		</Form>	
		<div className={cat.parentId?'hidden':''}>
		<Form id="catAttr" formData={cat.catAttr} onChange={onCatAttrChange}
			fields={[
				{id:"itemBankForceWorkFlow",ftype:"checkbox",field:"itemBankForceWorkFlow",label:t("Force workflow for item bank")},
				{id:"itemBankReviewers",ftype:"number",field:"itemBankReviewers",label:t("Number of reviewers")},
				{id:"itemBankFontFace",ftype:"dropdown",field:"itemBankFontFace",label:t("Default font for questions"),options:jwordFontList,optionLabel:"family",optionValue:"family"},			
				{id:"itemBankFontSize",ftype:"dropdown",field:"itemBankFontSize",label:t("Default font size"),options:jwordFontSizeList}
			]}>
		</Form>
		</div>
		</>
	);
}
export default RootForm;